<template>
  <div
    v-if="shouldRenderConfig && getPreview3D != ''"
    :class="[getClassName + 'Container', visible]"
  >
    <div :id="get3DPreviewId" class="vue-friendly-iframe">
      <iframe
        style="visibility: visible; border: none"
        :src="getPreview3D"
        crossorigin="anonymous"
        target="_parent"
        @load="onLoad"
      >
      </iframe>
    </div>
  </div>
</template>
<script>
import { usePreview3DStore } from "@/stores/modules/preview3D";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(usePreview3DStore, ["getPreview3D", "get3DPreviewId"])
  },
  methods: {
    ...mapActions(usePreview3DStore, [
      "setPreview3DLoading",
      "setPrintqChangeProductImage"
    ]),
    onLoad: function () {
      this.setPreview3DLoading(false);
    },
    printqChangeProductImageEvent: function (event) {
      if (event.detail) {
        this.setPrintqChangeProductImage(event.detail);
      }
    }
  },
  mounted: function () {
    window.document.addEventListener(
      "pqMatrix_set3dPreviewImage",
      this.printqChangeProductImageEvent
    );
  },
  props: ["visible"]
};
</script>
